import { render, staticRenderFns } from "./BuyingInfoNovationAnalysis.vue?vue&type=template&id=4df4e458&scoped=true&"
import script from "./BuyingInfoNovationAnalysis.vue?vue&type=script&lang=js&"
export * from "./BuyingInfoNovationAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BuyingInfoNovationAnalysis.vue?vue&type=style&index=0&id=4df4e458&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4e458",
  null
  
)

export default component.exports